export default __webpack_public_path__ + "static/media/carousel4.3a09db7e.png";